<template>
  <nuttrema-layout-form-standard :edit="edit" :saveError="CategoriesQuestionnaire.saveError">

    <template slot="center">
      <el-form
         label-width="20em"
        :ref="formRef"
        :model="formData">
        <template v-for="(categoryQuestionnaire, index) in _get(CategoriesQuestionnaire, 'data', [])">

          <section v-if="categoryQuestionnaire.field_type === 'section'">
            <h4 class="section-title">{{ categoryQuestionnaire.name }}</h4>
            <div class="section-items">
              <el-form-item
                 v-for="personHealthSubCategory in categoryQuestionnaire.SubCategories"
                :label="personHealthSubCategory.name"
                :key="personHealthSubCategory.id">
                <component
                   v-bind:is="'form-input-'+personHealthSubCategory.field_type"
                  :input="personHealthSubCategory"
                  :value="formData.CategoriesQuestionnaire"
                  :disabled="!edit"
                  :clearable="true"
                  @set:value="setValueEvent">
                </component>
              </el-form-item>
            </div>
          </section>

          <section v-else>
            <h4 v-if="index === 0" class="section-title">{{ $t(`label.${section}`) }}</h4>
            <div class="section-items">
              <el-form-item
                :label="categoryQuestionnaire.name"
                :key="categoryQuestionnaire.id">
                <component
                   v-bind:is="componentName(categoryQuestionnaire.field_type)"
                  :input="categoryQuestionnaire"
                  :value="formData.CategoriesQuestionnaire"
                  :disabled="!edit"
                  :clearable="true"
                  :behavior="_get(categoryQuestionnaire, 'behavior')"
                  @set:value="setValueEvent">
                </component>
              </el-form-item>
            </div>
          </section>

        </template>
      </el-form>
    </template>
    <!-- end ~ center -->

    <template slot="footer">
      <nav class="footer-row">
        <el-button size="small" type="primary" @click="submitForm" :loading="isSaving">{{ $t('label.save_changes') }}</el-button>
        <el-button size="small" type="text" @click="cancelChanges">{{ $t('label.cancel') }}</el-button>
      </nav>
    </template>
    <!-- end ~ footer  -->

  </nuttrema-layout-form-standard>
</template>

<script>
import Vue from 'vue';
import { assign, each, isNil, isEmpty, isArray } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import FormInputText from './form-input/cmpt-form-input-text';
import FormInputGroup from './form-input/cmpt-form-input-group';
import FormInputSelect from './form-input/cmpt-form-input-select';
import FormInputSimple from './form-input/cmpt-form-input-simple';
import FormInputComplex from './form-input/cmpt-form-input-complex';
import FormInputMultiSelect from './form-input/cmpt-form-input-multi-select';
import FormInputCheckboxGroup from './form-input/cmpt-form-input-checkbox-group';

export default {
  name: 'form-category-questionnaire',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    CategoriesQuestionnaire: {
      required: true,
      default: null,
    },
    section: {
      type: String,
      required: false,
      default: null,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  components: {
    FormInputText,
    FormInputGroup,
    FormInputSelect,
    FormInputSimple,
    FormInputComplex,
    FormInputMultiSelect,
    FormInputCheckboxGroup,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        CategoriesQuestionnaire: {},
      },
      original: {
        PersonLifeStageID: [],
        CategoriesQuestionnaire: {},
      },
    };
  },
  methods: {
    componentName(value) {
      const name = value.replace(/_/g, '-');
      return `form-input-${name}`;
    },
    setValueEvent(params) {
      Vue.set(this.formData.CategoriesQuestionnaire, params.code, params.data);
    },
    getFormData() {
      const payload = {
        entity_categories: [],
      };
      each(this.formData.CategoriesQuestionnaire, (category) => {
        const add = isArray(category.value) ? !isEmpty(category.value) : (!isNil(category.value) && category.value !== '');
        if (add) payload.entity_categories.push({ id: category.id, value: category.value });
      });
      return payload;
    },
    cancelChanges() {
      this.formData.PersonLifeStageID = this.original.PersonLifeStageID;
      this.formData.CategoriesQuestionnaireID = assign({}, this.original.CategoriesQuestionnaireID);
      this.$emit('update:edit', false);
      this.$emit('cancel');
      this.$nextTick(() => {
        this.$refs[this.formRef].clearValidate();
      });
    },
  },
  created() {
    this.formRef = 'form-category-questionnaire';
    this.stateData = this.CategoriesQuestionnaire;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/category-questionnaire/form-category-questionnaire.vue